import Model from "@tripian/model";

export type VisaErrorGroup =
  | "Client Enroll Fail"
  | "Card Validation Fail"
  | "Session Validation Fail"
  | "System Generic Error"
  | "Redemption Error"
  | "Data Combination Error"
  | "Redemption limit exceeded"
  | "Out of stock";

const errorCodeToGroup: Record<string, VisaErrorGroup> = {
  // System Generic Error
  CFG_0001: "System Generic Error",
  CFG_0002: "System Generic Error",
  CFG_0003: "System Generic Error",
  CFG_0004: "System Generic Error",
  CFG_0005: "System Generic Error",
  CFG_9999: "System Generic Error",
  SYS_0001: "System Generic Error",
  SYS_0002: "System Generic Error",
  SYS_0003: "System Generic Error",
  SYS_9999: "System Generic Error",
  USR_9999: "System Generic Error",
  CRD_9997: "System Generic Error",
  CRD_9998: "System Generic Error",
  CRD_9999: "System Generic Error",
  RDM_9999: "System Generic Error",

  // Client Enroll Fail
  USR_0001: "Client Enroll Fail",
  USR_0002: "Client Enroll Fail",
  USR_0003: "Client Enroll Fail",
  USR_0004: "Client Enroll Fail",
  USR_0005: "Client Enroll Fail",
  USR_0006: "Client Enroll Fail",
  USR_0007: "Client Enroll Fail",
  USR_0008: "Client Enroll Fail",
  USR_0009: "Client Enroll Fail",
  USR_0010: "Client Enroll Fail",
  USR_0011: "Client Enroll Fail",
  USR_0012: "Client Enroll Fail",
  RDM_0001: "Client Enroll Fail",
  RDM_0002: "Client Enroll Fail",
  RDM_0003: "Client Enroll Fail",
  RDM_0005: "Client Enroll Fail",
  RDM_0006: "Client Enroll Fail",

  // Card Validation Fail
  CRD_0001: "Card Validation Fail",
  CRD_0003: "Card Validation Fail",
  CRD_0005: "Card Validation Fail",
  CRD_0006: "Card Validation Fail",
  CRD_0007: "Card Validation Fail",
  CRD_0008: "Card Validation Fail",
  CRD_0009: "Card Validation Fail",
  CRD_0010: "Card Validation Fail",
  CRD_0011: "Card Validation Fail",
  CRD_0012: "Card Validation Fail",
  CRD_0013: "Card Validation Fail",

  // Redeemption Error
  CRD_0002: "Redemption Error",
  RDM_0008: "Redemption Error",
  RDM_0009: "Redemption Error",

  // Redemption limit exceeded
  CRD_0004: "Redemption limit exceeded",
  CRD_0014: "Redemption limit exceeded",
  RDM_0007: "Redemption limit exceeded",
  RDM_0010: "Redemption limit exceeded",

  // Out of stock
  RDM_0004: "Out of stock",
};

export function getErrorGroupFromCode(
  errorCode: string | undefined | null
): VisaErrorGroup {
  if (!errorCode) {
    return "System Generic Error";
  }
  const normalized = errorCode.trim().toUpperCase();
  return errorCodeToGroup[normalized] ?? "System Generic Error";
}

type TranslationKeys = {
  title: string;
  description: string;
};

type LocalizeOptions = {
  langCode?: string;
  debug?: boolean;
};

const groupToTranslationKeys: Record<VisaErrorGroup, TranslationKeys> = {
  "Client Enroll Fail": {
    title: "visa.error.clientEnrollFail.title",
    description: "visa.error.clientEnrollFail.description",
  },
  "Card Validation Fail": {
    title: "visa.error.cardValidationFail.title",
    description: "visa.error.cardValidationFail.description",
  },
  "Session Validation Fail": {
    title: "visa.error.sessionValidationFail.title",
    description: "visa.error.sessionValidationFail.description",
  },
  "System Generic Error": {
    title: "visa.error.systemGenericError.title",
    description: "visa.error.systemGenericError.description",
  },
  "Redemption Error": {
    title: "visa.error.redemptionError.title",
    description: "visa.error.redemptionError.description",
  },
  "Data Combination Error": {
    title: "visa.error.dataCombinationError.title",
    description: "visa.error.dataCombinationError.description",
  },
  "Redemption limit exceeded": {
    title: "visa.error.redemptionLimitExceeded.title",
    description: "visa.error.redemptionLimitExceeded.description",
  },
  "Out of stock": {
    title: "visa.error.outOfStock.title",
    description: "visa.error.outOfStock.description",
  },
};

export function getLocalizedErrorContentFromCode(
  t: (key: Model.TranslationKey) => string,
  errorCode: string | undefined | null
): { group: VisaErrorGroup; title: string; description: string } {
  const group = getErrorGroupFromCode(errorCode);
  const keys = groupToTranslationKeys[group];

  const title = t(keys.title as Model.TranslationKey);
  const description = t(keys.description as Model.TranslationKey);

  return { group, title, description };
}
